const success = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 426.667 426.667"
		width="20px"
		height="20px"
	>
		<polygon
			points="293.333,135.04 190.08,240.213 137.173,187.093 108.8,215.467 192.213,298.667 326.187,168.747"
			fill="#4f8a10"
		/>
		<path
			d="M213.333,0C95.513,0,0,95.513,0,213.333s95.513,213.333,213.333,213.333s213.333-95.513,213.333-213.333 S331.154,0,213.333,0z M213.333,388.053c-96.495,0-174.72-78.225-174.72-174.72s78.225-174.72,174.72-174.72 c96.446,0.117,174.602,78.273,174.72,174.72C388.053,309.829,309.829,388.053,213.333,388.053z"
			fill="#4f8a10"
		/>
	</svg>
);

export default success;
